import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MetaTags from '../components/common/MetaTags';
import './NotFoundPage.css';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found-page">
      <MetaTags
        title="Página Não Encontrada - SBX Trade"
        description="A página que você está procurando não existe ou foi movida. Redirecionando para a página inicial..."
        keywords="404, página não encontrada, SBX Trade, trade, trading"
        image="https://sbxtreinamentos.com.br/webinario/images/404-og-image.jpg"
        url="https://sbxtreinamentos.com.br/webinario/404"
        type="website"
        author="SBX Trade"
        siteName="SBX Trade"
        noIndex={true}
      />
      <div className="not-found-container">
        <div className="not-found-content">
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">Página não encontrada</h2>
          <p className="not-found-description">
            A página que você está procurando não existe ou foi movida.
          </p>
          <p className="not-found-redirect">
            Redirecionando para a página inicial em <span className="countdown">{countdown}</span> segundos...
          </p>
          <button 
            className="not-found-button"
            onClick={handleGoHome}
          >
            Ir para página inicial
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;